import { api_get } from '@lf/api-client/lfApi';

export class Thumbnail {
    constructor(url = '', width = 0, height = 0) {
        this.url = url;
        this.width = width;
        this.height = height;
    }

    static fromApi(data = {}) {
        if (!data) {
            return null;
        }
        const { url = '', width = 0, height = 0 } = data;
        return new Thumbnail(url, width, height);
    }
}

export class Thumbnails {
    constructor(defaultThumbnail = null, medium = null, high = null, standard = null) {
        this.default = defaultThumbnail;
        this.medium = medium;
        this.high = high;
        this.standard = standard;
    }

    static fromApi(data = {}) {
        if (!data) {
            return new Thumbnails();
        }
        return new Thumbnails(
            data.default ? Thumbnail.fromApi(data.default) : null,
            data.medium ? Thumbnail.fromApi(data.medium) : null,
            data.high ? Thumbnail.fromApi(data.high) : null,
            data.standard ? Thumbnail.fromApi(data.standard) : null,
        );
    }
}

export class Localized {
    constructor(description = '', title = '') {
        this.description = description;
        this.title = title;
    }

    static fromApi(data = {}) {
        if (!data) {
            return null;
        }
        const { description = '', title = '' } = data;
        return new Localized(description, title);
    }
}

export class Snippet {
    constructor({
        channelId = '',
        channelTitle = '',
        description = '',
        liveBroadcastContent = '',
        publishedAt = '',
        thumbnails = null,
        title = '',
        categoryId = null,
        localized = null,
        publishTime = null,
    } = {}) {
        this.channelId = channelId;
        this.channelTitle = channelTitle;
        this.description = description;
        this.liveBroadcastContent = liveBroadcastContent;
        this.publishedAt = publishedAt;
        this.thumbnails = thumbnails;
        this.title = title;
        this.categoryId = categoryId;
        this.localized = localized;
        this.publishTime = publishTime;
    }

    static fromApi(data = {}) {
        if (!data) {
            return null;
        }
        return new Snippet({
            channelId: data.channelId ?? '',
            channelTitle: data.channelTitle ?? '',
            description: data.description ?? '',
            liveBroadcastContent: data.liveBroadcastContent ?? '',
            publishedAt: data.publishedAt ?? '',
            thumbnails: data.thumbnails ? Thumbnails.fromApi(data.thumbnails) : null,
            title: data.title ?? '',
            categoryId: data.categoryId ?? null,
            localized: data.localized ? Localized.fromApi(data.localized) : null,
            publishTime: data.publishTime ?? null,
        });
    }
}

export class VideoID {
    constructor(kind = '', videoId = '') {
        this.kind = kind;
        this.videoId = videoId;
    }

    static fromApi(data = {}) {
        if (!data) {
            return null;
        }
        const { kind = '', videoId = '' } = data;
        return new VideoID(kind, videoId);
    }
}

export class SearchResult {
    constructor(etag = '', id = null, kind = '', snippet = null) {
        this.etag = etag;
        this.id = id;
        this.kind = kind;
        this.snippet = snippet;
    }

    static fromApi(data = {}) {
        if (!data) {
            return null;
        }
        return new SearchResult(
            data.etag ?? '',
            data.id ? VideoID.fromApi(data.id) : null,
            data.kind ?? '',
            data.snippet ? Snippet.fromApi(data.snippet) : null,
        );
    }
}

function normalizeResults(results) {
    if (!Array.isArray(results)) {
        return [];
    }
    return results
        .map((item) => SearchResult.fromApi(item))
        .filter((item) => item !== null);
}

export async function getYouTubeSearch(query, setError, timeout = 10000, channelId) {
    const params = { query };
    if (channelId) {
        params.channel_id = channelId;
    }
    const response = await api_get('/youtube/search', params, setError, timeout);
    if (!response || !response.data) {
        return { results: [] };
    }

    const { items = [] } = response.data;
    return { results: normalizeResults(items) };
}

export async function getYouTubeSearchHistory(params = {}, setError, timeout = 10000) {
    const response = await api_get('/youtube/search_history', params, setError, timeout);
    if (!response || !response.data) {
        return { items: [] };
    }

    const { items = [] } = response.data;
    return { items };
}
